/* TheStudiz – computer search bar with live book suggestions. Koi observer nahi. */
(function () {
  function money(v) {
    var n = parseFloat(v); if (isNaN(n)) return '';
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PKR';
    return (cur === 'PKR' ? 'Rs.' : cur + ' ') + Math.round(n).toLocaleString('en-US');
  }
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    var input = root.querySelector('[data-dsearch-input]');
    var box = root.querySelector('[data-dsearch-results]');
    var timer = null, controller = null;

    function hide() { box.hidden = true; box.textContent = ''; }

    function render(products, q) {
      box.textContent = '';
      if (!q) { box.hidden = true; return; }
      if (!products.length) {
        var e = document.createElement('p'); e.className = 'dsearch__empty';
        e.textContent = 'No books found for "' + q + '". Try another title, author or ISBN.';
        box.appendChild(e); box.hidden = false; return;
      }
      var ul = document.createElement('ul'); ul.className = 'dsearch__list';
      products.forEach(function (p) {
        var li = document.createElement('li');
        var a = document.createElement('a'); a.href = p.url; a.className = 'dsearch__item';
        if (p.image) {
          var im = document.createElement('img'); im.src = p.image; im.alt = ''; im.loading = 'lazy'; im.width = 56; im.height = 76; a.appendChild(im);
        }
        var txt = document.createElement('span'); txt.className = 'dsearch__text';
        var t = document.createElement('span'); t.className = 'dsearch__title'; t.textContent = p.title;
        var pr = document.createElement('span'); pr.className = 'dsearch__price'; pr.textContent = money(p.price);
        var cmp = parseFloat(p.compare_at_price_max);
        if (cmp > parseFloat(p.price)) { var s = document.createElement('s'); s.textContent = money(cmp); pr.appendChild(document.createTextNode(' ')); pr.appendChild(s); }
        txt.appendChild(t); txt.appendChild(pr); a.appendChild(txt); li.appendChild(a); ul.appendChild(li);
      });
      box.appendChild(ul);
      var all = document.createElement('a'); all.className = 'dsearch__all';
      all.href = ((window.routes && routes.search_url) || '/search') + '?q=' + encodeURIComponent(q);
      all.textContent = 'See all results for "' + q + '"';
      box.appendChild(all); box.hidden = false;
    }

    function search(q) {
      if (controller) controller.abort();
      if (!q) { render([], ''); return; }
      controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var base = (window.routes && routes.predictive_search_url) || '/search/suggest';
      fetch(base + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last',
        controller ? { signal: controller.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (d) { render((d.resources && d.resources.results && d.resources.results.products) || [], q); })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      timer = setTimeout(function () { search(q); }, 250);
    });
    input.addEventListener('focus', function () { if (box.childNodes.length) box.hidden = false; });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) box.hidden = true; });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
  }
  function boot() { document.querySelectorAll('[data-dsearch]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
